import { supportedLangs } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

const TransferCertificateEquipmentSchema = z.object({
  id: z.number().int(),
  name: z.string().min(1),
  serialNumber: z.string().nullable(),
  partNumber: z.string().nullable(),
  missing: z.boolean(),
});

const TransferCertificatePersonSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable(),
});

// The recipient is the one whose acceptance the certificate attests to, so
// unlike the sender's, their email is required — it identifies the signer,
// not just contact info.
const TransferCertificateSignerSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().min(1),
  registrationNumber: z.string().nullable(),
});

export const TransferCertificateDataSchema = z
  .object({
    transferId: z.number().int(),
    transferExternalId: z.string().nullable(),
    organizationName: z.string().min(1),
    fromUser: TransferCertificatePersonSchema,
    toUser: TransferCertificateSignerSchema,
    equipments: z.array(TransferCertificateEquipmentSchema).min(1),
    issuedAt: z.coerce.date(),
    completedAt: z.coerce.date(),
    receiverComment: z.string().nullable(),
    verificationUrl: z.string().url(),
    lang: z.enum(supportedLangs),
  })
  .refine((data) => data.equipments.some((e) => !e.missing), {
    message: 'A transfer certificate needs at least one non-missing item',
    path: ['equipments'],
  });

export class TransferCertificateDataDto extends createZodDto(
  TransferCertificateDataSchema,
) {}

export type TransferCertificateData = z.infer<
  typeof TransferCertificateDataSchema
>;
